import LoginRoutes from './LoginRoutes';

export default LoginRoutes;
